// odigeo, utils, polyfills
require('./odigeo.js');
require('./odigeo.pollyfills.js');
require('./odigeo.utils');

// jQuery libs
require('../../thirdParty/jquery/jquery.event.move.min');
require('../../thirdParty/jquery/jquery.event.swipe.min');
require('../../thirdParty/jquery/jquery.tap.min');
require('../../thirdParty/jquery/jquery.animate-enhanced.min');
require('../../thirdParty/jquery/jquery.animate-enhanced.promise.min');

// ui
require('./odigeo.ui.js');
require('./odigeo.ui.advertisement');
require('./odigeo.ui.backgroundTab');
require('./odigeo.ui.bubbleNotification');
require('./odigeo.ui.button');
require('./odigeo.ui.carousel');
require('./odigeo.ui.collapsive');
require('./odigeo.ui.dialogs');
require('./odigeo.ui.lightbox');

module.exports = Odigeo;
